<template>
  <span class="statusMark" :class="`statusMark__${status}`" />
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: [String,Number],
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';

.statusMark {
  border-radius: 50%;
  display: inline-block;
  width: 8px;
  height: 8px;

  // あえて番号で管理して意味を持たせない
  &__1 {
    background: $complete-color;
  }

  &__2 {
    background: $color-accent-primary;
  }

  &__3 {
    background: #D2D5DB;
  }
}
</style>
